import Vue from 'vue'
import Vuex from 'vuex'
import attendance from './attendance'
import csmstimetable from './csmstimetable'
import educationAffairs from './educationAffairs'
import evaluation from './evaluation'
import parentInfo from './parentInfo'
import infoPublic from './infoPublic'
import schoolAffairs from './schoolAffairs'
import common from './common'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)
const store = new Vuex.Store({
  state: {
    apiPath: '',
    globalNavBar_transparentMode: false, // 用于设置全局导航的透明模式，默认不开启
    messageInfo: '',
    apiPublic:''
  },
  mutations: {
    changeApiPath(state, path) {
      state.apiPath = path
    },
    changeApiPublic (state, path) {
      state.apiPublic = path
    },
    // 修改全局的导航栏背景色
    changeNavBg(state, status) {
      if (typeof status === 'boolean') {
        state.globalNavBar_transparentMode = status
      } else if (status === 'true' || status === 'false') {
        state.globalNavBar_transparentMode = status === 'true'
      } else {
        state.globalNavBar_transparentMode = false
      }
    },
    changeMessageInfo: function (state, info) {
      state.messageInfo = JSON.stringify(info)
    }

  },
  modules: {
    common,
    attendance,
    csmstimetable,
    educationAffairs,
    evaluation,
    parentInfo,
    infoPublic,
    schoolAffairs
  },
  plugins: [createPersistedState()]
})
export default store
